import React from 'react';
import { findExamCatalogItem, LEVEL_LABELS, LEVEL_SHORT_LABELS } from '../utils/examCatalog';
import './ExamBadge.css';

interface Props {
  code?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * 시험 코드별 고정 배지. AWS 공식 자격증 배지(상표)를 쓰지 않고, 등급 색과 시험 코드로 만든 자체 배지입니다.
 * 코드를 모르면 null을 돌려줘서 호출부가 기존 아이콘을 쓰게 합니다.
 */
const ExamBadge: React.FC<Props> = ({ code, size = 'md', className = '' }) => {
  const item = findExamCatalogItem(code);
  if (!item) return null;
  const [series, version] = item.code.split('-');
  return (
    <span
      className={`exam-badge exam-badge--${item.level} exam-badge--${size} ${className}`.trim()}
      role="img"
      aria-label={`${item.code} · ${LEVEL_LABELS[item.level]}`}
      title={`${item.name} (${item.code})`}
    >
      <span className="exam-badge__level">{LEVEL_SHORT_LABELS[item.level]}</span>
      <span className="exam-badge__code">{series}</span>
      <span className="exam-badge__version">{version}</span>
    </span>
  );
};

export default ExamBadge;
